<!-- Mobile hamburger button -->
@if (viewport.isMobile()) {
	<button
		class="mobile-nav-toggle"
		(click)="toggle()"
		aria-label="Toggle navigation">
		<i [class]="isOpen() ? 'fa-solid fa-times' : 'fa-solid fa-bars'"></i>
	</button>
}

<!-- Navigation backdrop overlay (mobile only) -->
@if (viewport.isMobile() && isOpen()) {
	<div
		class="nav-backdrop"
		(click)="toggle()"></div>
}

<div
	class="sidebar"
	[class.closed]="!isOpen()"
	[class.wide]="isOpen() && canViewPartCodingAdmin()"
	style="height: 100vh">
	@if (isOpen()) {
		<div class="logo">
			<img
				src="../../assets/RK_Logo_Color.png"
				alt="Logo"
				style="width: 120px; height: 76px"/>
		</div>
	}
	<nav
		style="flex: 1; height: 100vh"
		class="fade-in"
		[class.visible]="isOpen()">
		<ul class="w-9 mx-auto">
			@if (canViewEFiling()) {
				<li
					routerLink="/e-filing"
					(click)="closeMobileNav()">
					<div class="nav-li">
						<i class="fa-solid fa-wallet"></i>
						<button>E-Filing</button>
					</div>
				</li>
			}


			@if (canViewQuoteLog()) {
				<li
					routerLink="/quote-log"
					(click)="closeMobileNav()">
					<div class="nav-li">
						<i class="fa-solid fa-file-lines"></i>
						<button>Quote Log</button>
					</div>
				</li>
			}

			@if (canViewPartCoding()) {
				<li
					routerLink="/part-coding"
					(click)="closeMobileNav()">
					<div class="nav-li">
						<i class="fa-solid fa-code"></i>
						<button class="pad-left">Part Coding</button>
					</div>
				</li>
			}

			@if (canViewPartCodingAdmin()) {
				<li
					routerLink="/part-coding-admin"
					(click)="closeMobileNav()">
					<div class="nav-li">
						<i class="fa-solid fa-code"></i>
						<button class="pad-left">Admin Part Coding</button>
					</div>
				</li>
			}

			@if (canViewReporting()) {
				<li
					routerLink="/reporting"
					(click)="closeMobileNav()">
					<div class="nav-li">
						<i class="fa-solid fa-chart-column"></i>
						<button>Reporting</button>
					</div>
				</li>
			}

			@if (canViewTesting()) {
				<li
					routerLink="/so-gap"
					(click)="closeMobileNav()">
					<div class="nav-li">
						<i class="fa-solid fa-clipboard-check"></i>
						<button>SO Gap</button>
					</div>
				</li>
			}
		</ul>
	</nav>

	<div class="mt-auto mx-auto mb-3">
		<p-button
			label="Sign Out"
			(onClick)="signOut()"
			class="mt-auto"
			[styleClass]="'embark-bg-blue opacity-70 text-sm'"></p-button>
	</div>

	@if (canViewTesting()) {
		<div class="mt-auto mx-auto mb-3">
			<p-button
				label="Settings"
				(onClick)="adminActions()"
				class="mt-auto"
				icon="pi pi-cog"
				[styleClass]="'embark-bg-blue opacity-70 text-sm'"
			></p-button>
		</div>
	}
</div>
